var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured-projects"
  }, [_c('header', _vm._l((_vm.skill_tags), function(tag) {
    return _c('CmChiclet', _vm._b({
      key: tag.value
    }, 'CmChiclet', {
      type: 'radio',
      group: 'projects_skill_tags',
      value: tag.value,
      label: tag.label,
      checked: tag.value === _vm.skill_tags,
    }, false))
  })), _vm._v(" "), _c('CmMasonryLayout', {
    staticClass: "projects-list"
  }, _vm._l((_vm.results), function(result) {
    return _c('ProjectCard', {
      key: result.id,
      attrs: {
        "project": result
      }
    })
  }))], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffd1e35e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-projects.vue
// module id = null
// module chunks = 